import React from 'react'
import CustomTitle from '../../components/UI/title/CustomTitle'
import Review from '../../components/Review/Review'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

export default function CaseContent({ id }) {

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);


    const content = [{
        title: queryParams.get('stage-id')=== '1' ? "“I got 400+ new orders”" : "“I've got 500+ new clients”",
        name: queryParams.get('stage-id')=== '1' ? "Scarlette Goff" : "Phoebe Holden",
        date: queryParams.get('stage-id')=== '1' ? "4 weeks ago" : "2 weeks ago",
        text: queryParams.get('stage-id')=== '1' ? "My sales conversions have increased by 340%, all thanks to Zeely. The viral AI video creatives are smashing it. I'm swamped with hoodie orders –400+<br>new orders and I just can't keep up" : "In just three months with Zeely, I've got 500+ new clients for my services. I didn't hire a single outside expert, just used AI video creatives with high CTR and launched some killer ad campaigns on IG.",
        stat: queryParams.get('stage-id')=== '1' ? "stat2.webp" : "stat1.webp",
        img: queryParams.get('stage-id')=== '1' ? "avatar2.webp" :  "avatar1.webp"
    },{
        title: "“Sales went up 3 times”",
        name: "Lucas Drake",
        date: "1 week ago",
        text: "I was getting some sales with just video ads, but once I combined them with AI-powered static banners, it was a game changer. Sales went up 3 times, and my engagement skyrocketed!",
        stat: "stat3.webp",
        img: "avatar3.webp"
    },{
        title: "“239% growth in 3 months”",
        name: "Ellis Spencer",
        date: "1 week ago",
        text: "Growing my sales by 239% in 3 months taught me one big lesson: don't put all your eggs in one basket. To really nail your promotions, mix static and video creatives with killer ad campaigns.",
        stat: "stat4.webp",
        img: "avatar4.webp"
    },{
        title: "“I overperformed my goal”",
        name: "Mark V. Powell",
        date: "4 weeks ago",
        text: 'Got into Zeely with a goal that seemed way out there. Just stuck with it, rolled with the plan,  played around with the AI tools, and bam! I overperformed my goal."',
        stat: "stat5.webp",
        img: "avatar5.webp"
    }
]

    return (
        <>
            <CustomTitle style={{ marginBottom: "24rem" }} title={content[id].title} />
            <Review style={{ marginBottom: "16rem" }} img={content[id].img} name={content[id].name} date={content[id].date} text={content[id].text} />
            <div style={{ aspectRatio: "303/172" }}>
                <img src={process.env.PUBLIC_URL + `/img/case/${content[id].stat}`} alt="" />
            </div>
        </>
    )
}
